import { Component } from '@angular/core';

import { ApplicationTilesComponent } from '../application-tiles/application-tiles.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [ApplicationTilesComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
}
